/**
 * INIT
 *
 * This function initializes all modules used on the site, try to keep it as
 * simple as possible moving any complicated logic into the modules itself
 */
const Init = function () {
	const Global = handleModule(import('./global'))
	const Tracking = handleModule(import('./tracking'))
	const Dialog = handleModule(import('./dialog'))
	const Details = handleModule(import('./details'))
	const ImageMap = handleModule(import('./imagemap'))
	const Parallax = handleModule(import('./parallax'))
	const HeroSlider = handleModule(import('./hero-slider'))
	const ImageSlider = handleModule(import('./image-slider'))
	const FloatingButtons = handleModule(import('./floating-buttons'))
	const Buttons = handleModule(import('./buttons'))
	const OverlayFormTeaser = handleModule(import('./overlay-form-teaser'))
	const Homepage = handleModule(import('./homepage'))

	import('./filtergroups')

	window.DEHN = {
		Global,
		Tracking,
		Dialog,
		Details,
		ImageMap,
		Parallax,
		HeroSlider,
		ImageSlider,
		FloatingButtons,
		Buttons,
		OverlayFormTeaser,
		Homepage,
	}
}

Init()


function handleModule(module) {
	return module.then(handleModuleSuccess).catch(handleModuleError)
}

function handleModuleSuccess({ default: module }) {
	module.init()
}

function handleModuleError(error) {
	console.error(error)
}
